export function LaunchIcon({ className = "" }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.7733 20.7867L22.2267 17.3333H9.33333V14.6667H22.2267L18.7733 11.2133L20.6667 9.33333L27.3333 16L20.6667 22.6667L18.7733 20.7867ZM25.3333 4C26.0406 4 26.7189 4.28095 27.219 4.78105C27.719 5.28115 28 5.95942 28 6.66667V12.8933L25.3333 10.2267V6.66667H6.66667V25.3333H25.3333V21.7733L28 19.1067V25.3333C28 26.0406 27.719 26.7189 27.219 27.219C26.7189 27.719 26.0406 28 25.3333 28H6.66667C5.95942 28 5.28115 27.719 4.78105 27.219C4.28095 26.7189 4 26.0406 4 25.3333V6.66667C4 5.18667 5.18667 4 6.66667 4H25.3333Z"
        fill="#393939"
      />
    </svg>
  );
}
